import KPICard from './KpiCard';

const KPIPreview = ({ kpiPreviewData }: any) => {
  return <KPICard chartData={kpiPreviewData} isDashboardLayout={false} />;
};

export default KPIPreview;
